import {useLocation, useNavigate} from "@tanstack/react-router";

export interface EntityTab<TId extends string = string> {
  id: TId;
  label: string;
  to: string;
}

export interface UseEntityNavigationOptions<TId extends string = string> {
  tabs: readonly EntityTab<TId>[];
  overviewTab: EntityTab<"overview">;
  basePathSegment: string;
}

export function useEntityNavigation<TId extends string = string>({
  tabs,
  overviewTab,
  basePathSegment,
}: UseEntityNavigationOptions<TId>) {
  const location = useLocation();
  const navigate = useNavigate();

  const mobileTabs = [overviewTab, ...tabs] as const;

  const segments = location.pathname.split("/").filter(Boolean);
  const lastSegment = segments[segments.length - 1] ?? "";

  let selectedKey = mobileTabs.find((t) => t.id === lastSegment)?.id;

  if (!selectedKey && lastSegment === basePathSegment) {
    selectedKey = "overview";
  }

  const desktopSelectedKey = selectedKey === "overview" ? "" : (selectedKey ?? tabs[0]?.id);
  const mobileSelectedKey = selectedKey ?? mobileTabs[0]?.id;

  function onMobileTabChange(key: string | number) {
    const tab = mobileTabs.find((t) => t.id === key);

    if (tab) {
      void navigate({to: tab.to});
    }
  }

  return {
    tabs,
    mobileTabs,
    selectedKey,
    desktopSelectedKey,
    mobileSelectedKey,
    onMobileTabChange,
  };
}
